import React, { useEffect, useRef } from "react";
import InfoSection from "@components/pages/info/info_section";
import { Button, Form, FormControl, FormLabel } from "react-bootstrap";
import { useRouter } from "next/router";
import { useState } from "react";
import { FlexContainer } from "@components/ui/flex_container";
import { fetcherNew1819 } from "@utils/fetcherNew1819";
import ReCAPTCHA from "react-google-recaptcha";
import toast from "react-hot-toast";
import { LOGIN_PATH } from "@utils/constants";

function ServiceNumber() {
    const router = useRouter();
    const reCaptchaRef = useRef();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [router.pathname]);

    const [formName, setFormName] = useState("");
    const [formEmail, setFormEmail] = useState("");
    const [formPhone, setFormPhone] = useState("");
    const [formMessage, setFormMessage] = useState("");
    const [isSending, setIsSending] = useState(false);
    const [successfullySent, setSuccessfullySent] = useState(false);
    const [validated, setValidated] = useState(false);

    let defaultMessage = "";
    if (formMessage.length === 0 && router.query.leit) {
        defaultMessage = `Ekkert fannst með leitarorðinu "${router.query.leit}".\nÁbending:\n`;
        setFormMessage(defaultMessage);
    }

    if (successfullySent) {
        return (
            <InfoSection title="Hafa samband">
                <FlexContainer
                    column
                    justifyContent="center"
                    alignItems="center"
                    className="text-center pt-3 pb-3"
                >
                    <img
                        className="success-icon"
                        style={{ width: 50, marginBottom: 20 }}
                        src={"/img/circled-checkmark.svg"}
                    />
                    <div>Þakka þér fyrir að hafa samband.</div>

                    <div>Við munum svara fyrirspurninni við fyrsta tækifæri.</div>
                </FlexContainer>
            </InfoSection>
        );
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return;
        }
        const token = await reCaptchaRef.current.executeAsync();
        if (token === null) {
            toast("Vinsamlegast staðfestu að þú sért ekki vélmenni");
            return;
        }
        setIsSending(true);

        let formBody = [];

        let details = {
            name: formName,
            netfang: formEmail,
            phone: formPhone,
            message: formMessage,
        };
        for (let property in details) {
            if (!details[property]) {
                continue;
            }
            let encodedKey = encodeURIComponent(property);
            let encodedValue = encodeURIComponent(details[property]);

            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");
        fetcherNew1819("1819/mail/contact-us", "POST", {
            send_to: "1819@1819.is",
            subject: "Ný skilaboð frá 1819.is",
            name: formName,
            phone: formPhone,
            email: formEmail,
            description: formMessage,
            captchaToken: token,
        })
            .then(() => {
                setIsSending(false);
                setSuccessfullySent(true);
            })
            .catch((e) => {
                console.log(e);
                setIsSending(false);
                setSuccessfullySent(false);
            })
            .finally(() => {
                reCaptchaRef?.current?.reset?.();
            });
    };

    return (
        <InfoSection title="Hafa samband">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <FormLabel htmlFor="nameInput">
                    Nafn <span style={{ color: "#cf0000" }}>*</span>
                </FormLabel>
                <FormControl
                    value={formName}
                    onChange={(e) => setFormName(e.target.value)}
                    id="nameInput"
                    type="text"
                    placeholder="Nafn"
                    required
                />
                <Form.Control.Feedback type="invalid" className="mb-3">
                    Vinsamlegast gefðu upp nafn.
                </Form.Control.Feedback>

                <FormLabel htmlFor="nameInput">
                    Netfang <span style={{ color: "#cf0000" }}>*</span>
                </FormLabel>
                <FormControl
                    value={formEmail}
                    onChange={(e) => setFormEmail(e.target.value)}
                    id="nameInput"
                    type="text"
                    placeholder="Netfang"
                    required
                />
                <Form.Control.Feedback type="invalid" className="mb-3">
                    Vinsamlegast gefðu upp netfang.
                </Form.Control.Feedback>
                <FormLabel htmlFor="nameInput">Símanúmer</FormLabel>
                <FormControl
                    value={formPhone}
                    onChange={(e) => setFormPhone(e.target.value)}
                    id="nameInput"
                    type="text"
                    placeholder="Símanúmer"
                    className="mb-3"
                />
                <FormLabel htmlFor="nameInput">
                    Skilaboð <span style={{ color: "#cf0000" }}>*</span>
                </FormLabel>
                <FormControl
                    value={formMessage}
                    onChange={(e) => setFormMessage(e.target.value)}
                    as="textarea"
                    rows="5"
                    id="nameInput"
                    type="textarea"
                    placeholder="Erindi"
                    required
                    style={{ minHeight: 400 }}
                />
                <Form.Control.Feedback type="invalid" className="mb-3">
                    Vinsamlegast skrifaðu erindið þitt.
                </Form.Control.Feedback>

                <ReCAPTCHA
                    size="invisible"
                    style={{ display: "none" }}
                    ref={reCaptchaRef}
                    sitekey={process.env.RECAPTCHA_SITE_KEY}
                />

                <Button
                    type="submit"
                    disabled={isSending}
                    className="btn btn-primary mb-2 mt-3"
                    style={{ width: "100%" }}
                >
                    Senda
                </Button>
                <div className="text-center mt-3 mb-3 text-muted">
                    Viltu breyta eða eyða út skráningunni þinni? Þú getur skráð þig inn á Mitt 1819{" "}
                    <a href={LOGIN_PATH} style={{ textDecoration: "underline" }}>
                        hér
                    </a>
                    .
                </div>
            </Form>
        </InfoSection>
    );
}
export default ServiceNumber;
